import Image from "next/image";
import { useRef, useState } from "react";
import Slider from "react-slick";

export default function ClientTestimonialSlider({ data, forOther = false }) {
  const [reload, setReload] = useState(false);
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  const testimonialImageSlider = useRef();
  const nextClicked = () => {
    testimonialImageSlider.current.slickNext();
    setReload(!reload);
  };
  const previousClicked = () => {
    testimonialImageSlider.current.slickPrev();
    setReload(!reload);
  };

  return (
    <div className="pt-0 pb-20 px-4 md:py-16 md:px-10 bg-primary-black overflow-hidden">
      <div className="flex justify-center items-center relative">
        <div
          className="w-12 h-12 md:w-20 md:h-20 absolute -bottom-8 left-1/4 md:left-10 md:bottom-auto"
          role="presentation"
          onClick={previousClicked}
        >
          <Image
            alt="arrow"
            className="w-12 left-36 md:left-auto z-50 md:w-20 cursor-pointer transition-all duration-500 ease-out hover:scale-90 hover:ease-in"
            loading="lazy"
            src="/assets/careers/left-arrow.webp"
            width={80}
            height={80}
          />
        </div>
        <div className="w-full md:w-4/5 xl:w-5/6">
          <Slider
            {...settings}
            ref={(slider) => (testimonialImageSlider.current = slider)}
          >
            {data.map((element) => (
              <div
                key={element.image}
                className="!flex justify-center items-center my-0 mx-auto"
              >
                <div className="w-full mb-6 md:mb-0 md:w-3/5 text-center">
                  <div className="text-center fs-0">
                    <Image
                      alt="profile"
                      role="presentation"
                      src={element.image}
                      title={element.title}
                      className="w-fit !inline-block"
                      width={150}
                      height={150}
                    />
                  </div>
                  <p className="mt-12 mb-4 text-white text-base md:text-lg">
                    <span>{element.description ?? element.details}</span>
                  </p>
                  <p className="text-base text-gray-200 text-opacity-50">
                    {forOther === true
                      ? element.name + " " + element.designation + " "
                      : element.name +
                        (element.company && element.designation
                          ? "( " +
                            element.company +
                            ",  " +
                            element.designation +
                            " )"
                          : "")}
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div
          className="w-12 h-12 md:w-20 md:h-20 absolute -bottom-8 md:bottom-auto right-1/4 md:right-10"
          role="presentation"
          onClick={nextClicked}
        >
          <Image
            alt="arrow"
            className="relative w-12 md:w-20 right-36 md:right-auto cursor-pointer transition-all duration-500 ease-out hover:scale-90 hover:ease-in"
            loading="lazy"
            src="/assets/careers/right-arrow.webp"
            width={80}
            height={80}
          />
        </div>
      </div>
    </div>
  );
}
